import { MdWarning } from "react-icons/md";

export default function Jobpostcancelepopup({
  handlePopup,
  image,
  content,
  buttontext,
  onClick,
  closeThisPopUP,
  popUpInitialValue,
}) {
  return (
    <>
      {popUpInitialValue ? (
        <div
          onClick={() => closeThisPopUP}
          className="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm bg-black bg-opacity-50"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-[#F3F3F3] p-6 rounded-lg shadow-lg  w-[85%] md:w-[40%] lg:w-[40%]"
          >
            {/* <AiFillCloseCircle
              className="text-primary absolute text-2xl cursor-pointer  top-2 right-2"
              onClick={closeThisPopUP}
            /> */}
            <div className="flex flex-col items-center">
              <MdWarning className="text-6xl text-[#ff6b00]" />
              <p className=" text-center text-2xl mt-4">{content}</p>
            </div>
            <div className="m-6   md:ml-[90px] whitespace-nowrap md:w-[70%] w-[90%] md:mr-0    flex  justify-between ">
              <button className="underline text-lg" onClick={onClick}>
                Sure
              </button>
              <button
                onClick={closeThisPopUP}
                className="text-white border-1   bg-[#ff6b00] px-10 py-2 rounded-lg  "
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}
